<script lang="ts">
  import Icon from "../components/Icon.svelte";
    import ButtonBase from "./ButtonBase.svelte";

    export let style = "";
    export let disabled = false;
    export let loading = false;
    export let className = "";
    export let icon = "";
    export let iconSize: number | string = 10;
    export let iconColor = "#30A059";
    export let title = "";
    export let size: number | string = 16;
</script>

<ButtonBase on:click className={`size-${size} flex items-center justify-center rounded-full ${className}`} {disabled} {loading} {style}>
    {#if icon}
        <Icon {icon} size={iconSize} color={iconColor} />
    {/if}
    <slot />
</ButtonBase>
{#if title}
    { title }
{/if}

<style>
</style>
